<template>
    <div class="facemenu-box mt-5">
        <div class="facemenu-btn">
            <div class="facemenu-ladies">
              <div class="menu-headline">
                <h4>{{ faceMenu }}</h4>
              </div>
              <div
                v-for="(item, index) in faceMenuListLadies"
                :key="'ladies-' + index"
                :id="item.type"
                :class="`ladies-${item.type}`"
              >
                <a :href="item.link" target="_blank" class="facemenu-detail">
                  <img
                    :src="width > 900 ? item.img : item.spImg"
                    :alt="item.menu"
                    :class="{ 'facemenu-img-sp': width <= 900 }"
                  />
                  <div class="position-absolute text-white" :class="`ladies-${item.type}-title`">
                    <p>{{ item.menu }}</p>
                  </div>
                </a>
                <div class="text-start top-100 mt-3">
                  <p class="description">{{ item.description }}</p>
                </div>
              </div>
            </div>

            <div class="facemenu-mens">
              <div
                v-for="(item, index) in faceMenuListMens"
                :key="'mens-' + index"
                :id="item.type"
                :class="`mens-${item.type}`"
              >
                <a :href="item.link" target="_blank" class="facemenu-detail">
                  <img
                    :src="width > 900 ? item.img : item.spImg"
                    :alt="item.menu"
                    :class="{ 'facemenu-img-sp': width <= 900 }"
                  />
                  <div class="position-absolute text-white" :class="`mens-${item.type}-title`">
                    <p>{{ item.menu }}</p>
                  </div>
                </a>
                <div class="text-start top-100 mt-3">
                  <p class="description">{{ item.description }}</p>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>

const faceMenuListLadies = [
    {
        type: "hifu",
        menu: "医療ハイフ (レディース)",
        link: "https://eminal-clinic.jp/hifu/",
        description: "ショット数無制限！切らずにリフトアップが目指せるエミナルクリニックの医療ハイフ。",
        img: require("@/assets/images/pc/menu_ladies_hifu.png"),
        spImg: require("@/assets/images/sp/menu_ladies_hifu.png"),
    },
    {
        type: "dermapen",
        menu: "ダーマペン (レディース)",
        link: "https://eminal-group.jp/dermapen/",
        description: "お肌のお悩みの改善が期待できるエミナルクリニックのエイジングケア治療。",
        img: require("@/assets/images/pc/menu_ladies_dermapen.png"),
        spImg: require("@/assets/images/sp/menu_ladies_dermapen.png"),
    }

];

const faceMenuListMens = [
    {
        type: "hifu",
        menu: "医療ハイフ (メンズ)",
        link: "https://mens-eminal.jp/lp/hifu.php",
        description: "ショット数無制限！切らずにリフトアップが目指せるエミナルクリニックメンズの医療ハイフ。",
        img: require("@/assets/images/pc/menu_mens_hifu.png"),
        spImg: require("@/assets/images/sp/menu_mens_hifu.png"),
    },
    {
        type: "dermapen",
        menu: "ダーマペン (メンズ)",
        link: "https://mens-eminal.jp/dermapen_mens/",
        description: "お肌のお悩みの改善が期待できるエミナルクリニックメンズのエイジングケア治療。",
        img: require("@/assets/images/pc/menu_mens_dermapen.png"),
        spImg: require("@/assets/images/sp/menu_mens_dermapen.png"),
    }
];

export default({
    props: {
        'refmedia' : {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            faceMenu: "フェイスメニュー",
            faceMenuListLadies: faceMenuListLadies,
            faceMenuListMens: faceMenuListMens,
            bigFrameImg: require("@/assets/images/pc/bigframe.jpg"),
            spBigFrameImg: require("@/assets/images/sp/bigframe.jpg"),
            width: this.$store.state.width
        }
    },
    created() {
        if (this.refmedia !== "") {
            this.faceMenuListLadies.forEach(item => { item.link += "?refmedia=" + this.refmedia; });
            this.faceMenuListMens.forEach(item => { item.link += "?refmedia=" + this.refmedia; });
        }
    },
    mounted() {
        window.addEventListener('resize', this.resizeWindow)
    },
    methods: {
        resizeWindow() {
            this.width = window.outerWidth
        }
    },
})
</script>

<style scoped>

    .facemenu-ladies {
        width: 450px;
        display: block;
        border-top: 5px solid #E95A8E;
        padding: 3em 2em;
        background: linear-gradient(135deg, rgba(251,231,252,0.2) 0%, #FFF4FA 50%, rgba(255,229,244,0.1) 100%);
    }

    .facemenu-mens {
        width: 450px;
        border-top: 5px solid #707070;
        padding: 6.2em 2em 3em;
        background: linear-gradient(135deg, rgba(229,229,229,0.2) 0%, rgba(239,239,239,0.95) 50%, rgba(255,255,255,0.1) 100%);
    }

    .facemenu-btn {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
    }

    .ladies-hifu,
    .mens-hifu,
    .ladies-dermapen,
    .mens-dermapen,
    .ladies-photofacial,
    .mens-photofacial
    /* .ladies-mesotherapy,
    .mens-mesotherapy */ {
        width:100%;
    }

    h4 {
        text-align: left;
        margin-bottom: 1em;
    }

    .facemenu-detail {
        position: relative;
    }

    .ladies-hifu-title,
    .mens-hifu-title,
    .ladies-dermapen-title,
    .mens-dermapen-title,
    .ladies-photofacial-title,
    .mens-photofacial-title
    /* .ladies-mesotherapy-title,
    .mens-mesotherapy-title */ {
        top: 0;
        left: 0;
        right: 45%;
        font-size: 14px;
    }

    .description {
        margin-inline: 3%;
    }

    @media screen and (max-width: 900px) {
        .facemenu-ladies,
        .facemenu-mens,
        .facemenu-box {
            width: 100%;
        }

        .facemenu-btn {
            display: block;
        }

        .ladies-hifu,
        .mens-hifu,
        .ladies-dermapen,
        .mens-dermapen {
            width:100%;
        }

        h4 {
            text-align: center;
        }

        .menu-headline {
            top: 3% !important;
        }

        .ladies-hifu-title,
        .ladies-dermapen-title,
        .ladies-photofacial-title {
            right: 48%;
        }

        .mens-hifu-title,
        .mens-dermapen-title,
        .mens-photofacial-title {
            right: 49%;
        }

        .ladies-hifu-title,
        .mens-hifu-title,
        .ladies-dermapen-title,
        .mens-dermapen-title,
        .ladies-photofacial-title,
        .mens-photofacial-title {
            font-size: clamp(12px,2.6vw,20px);
        }

        .facemenu-img-sp {
            width: 80vw;
            height: 23vw;
        }

        .description {
            margin: 2% auto 5%;
            width: 80%;
            font-size: clamp(12px,2.1vw,16px);
        }
    }
</style>
